import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setBooking, setStep } from "../../../Reducer/bookingSlice";
import NextPrev from "../../../Helpers/Components/NextPrev";
import { useAuth } from "../../../Contexts/AuthenticateProvider"
import Select from 'react-select'
import Handler from "../../../Helpers/Components/Handler";
import { toast } from "react-toastify";

const Booking = (props) => {
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false)
    const { userDetails } = useAuth()
    const [leadList, setLeadList] = useState([])
    const booking = useSelector(state => state?.booking?.booking)
    const setSteps = () => {
        dispatch(setStep(2))
    }
    const handleNext = async () => {
        dispatch(setStep(0))
    }
    const getLeadList = async () => {
        setLoading(true)
        const response = await Handler({ method: "get", url: "/booking/lead-list" })
        setLoading(false)
        if (response?.success) {
            setLeadList(response?.data?.length ? response?.data?.map(element => { return { label: element?.name?.toUpperCase(), value: element?.leadId } }) : [])
        } else {
            setLeadList([])
        }
    }
    const setPreview = () => {
        if (!booking?.lead?.mode) {
            toast.error("Lead Mode is required")
        } else if (!booking?.lead?.staffId) {
            toast.error("Lead Attended by is required")
        } else {
            props?.setPreview(true)
        }
    }
    useEffect(() => {
        getLeadList()
    }, [])
    return (
        <React.Fragment>
            <div className="row">
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="carId" className="form-label"> Lead Mode </label>
                        <Select
                            onChange={(selectedoption) => {
                                dispatch(setBooking({ lead: { ...booking?.lead, mode: selectedoption?.value } }))
                            }}
                            styles={{
                                control: (base, state) => ({
                                    ...base,
                                    borderColor: state.isFocused ? "#f16436" : base.borderColor,
                                    boxShadow: state.isFocused ? "0 0 0 1px #f16436" : "none",
                                    "&:hover": {
                                        borderColor: "#f16436"
                                    }
                                }),
                                option: (style, state) => ({
                                    ...style,
                                    backgroundColor: state.isSelected
                                        ? "#f16436"
                                        : (state.isFocused || state.isActive)
                                            ? "#f164361a"
                                            : "white",
                                    color: state.isSelected ? "white" : "black"
                                })
                            }}
                            value={booking?.lead?.mode ? { label: booking?.lead?.mode, value: booking?.lead?.mode } : ""}
                            options={[{ label: "DC", value: "DC" }, { label: "LC", value: "LC" }, { label: "EC", value: "EC" },
                            { label: "Walkin", value: "Walkin" },
                            { label: "Whatsapp", value: "Whatsapp" },
                            { label: "Other", value: "Other" }]}
                        />
                    </div>
                </div>
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="carId" className="form-label"> Lead Attended By </label>
                        <Select
                            styles={{
                                control: (base, state) => ({
                                    ...base,
                                    borderColor: state.isFocused ? "#f16436" : base.borderColor,
                                    boxShadow: state.isFocused ? "0 0 0 1px #f16436" : "none",
                                    "&:hover": {
                                        borderColor: "#f16436"
                                    }
                                }),
                                option: (style, state) => ({
                                    ...style,
                                    backgroundColor: state.isSelected
                                        ? "#f16436"
                                        : (state.isFocused || state.isActive)
                                            ? "#f164361a"
                                            : "white",
                                    color: state.isSelected ? "white" : "black"
                                })
                            }}
                            onChange={(selectedOption) => {
                                dispatch(setBooking({ lead: { ...booking?.lead, staffId: selectedOption?.value, name: selectedOption?.label } }))
                            }}
                            value={booking?.lead?.staffId ? { label: booking?.lead?.name, value: booking?.lead?.staffId } : ""}
                            options={leadList}
                        />
                    </div>
                </div>
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="carId" className="form-label"> Booking Given By </label>
                        <input onChange={(e) => { }} name="location" id="location" autoComplete="off" disabled className="form-control input-theme text-uppercase" value={userDetails?.name || ""} />
                    </div>
                </div>
            </div>
            <NextPrev step={3} setStep={setSteps} last={2} onClick={handleNext} loading={loading} />
            <div className="text-center mt-4"><button className="btn btn-theme" disabled={loading} onClick={() => { setPreview() }}>{loading ? <i className="fa-solid fa-spinner fa-spin"></i> : "Preview"}</button></div>
        </React.Fragment>
    )
}

export default Booking